var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$store.state.clinicHistory.sidebarHidden
    ? _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _c(
          "div",
          {
            staticClass: "b-sidebar shadow bg-light text-dark sidebar-shadow",
            class: _vm.containerClass,
            style: _vm.containerStyle,
            attrs: { role: "dialog", "aria-modal": "false" }
          },
          [
            _c("div", { staticClass: "b-sidebar-body" }, [
              _c("div", { class: _vm.expanded ? "p-3 text-center" : "" }, [
                _c(
                  "nav",
                  { staticClass: "sidebar-history", style: _vm.navStyle },
                  [
                    _c(
                      "ul",
                      {
                        staticClass: "nav flex-column",
                        class: { "ul-right": _vm.rightSide }
                      },
                      _vm._l(_vm.sidebarData, function(item) {
                        return _c(
                          "li",
                          { key: item.title, style: _vm.liStyle },
                          [
                            _vm.expanded
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    style: _vm.liSpanStyle,
                                    attrs: { title: item.title, href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.rightSide
                                          ? item.action()
                                          : _vm.goToSection(item.id)
                                      }
                                    }
                                  },
                                  [
                                    _c("b", {
                                      domProps: {
                                        innerHTML: _vm._s(item.title)
                                      }
                                    })
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "icon-in-li",
                                    style: _vm.liSpanStyle,
                                    on: {
                                      click: function($event) {
                                        _vm.rightSide
                                          ? item.action()
                                          : _vm.goToSection(item.id)
                                      }
                                    }
                                  },
                                  [
                                    _c("base-icon", {
                                      staticClass: "cursor-pointer",
                                      attrs: {
                                        src:
                                          "" +
                                          _vm.iconBasePath +
                                          item.id +
                                          ".svg",
                                        alt: item.title,
                                        title: item.title,
                                        height: _vm.iconSize,
                                        width: _vm.iconSize,
                                        color: _vm.BLUE_COLOUR
                                      }
                                    })
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            !item.hideHr
                              ? _c("hr", { staticClass: "history-sidebar-hr" })
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8bbfa9d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bbfa9d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/ClinicHistorySectionsSidebar.vue
// module id = 2019
// module chunks = 116